import { graphql } from '../gql';

export const getUpcomingCateringEventDetails = graphql(`
  query GetUpcomingCateringEventDetails($input: GetEventVendorsInput!) {
    getEventVendors(input: $input) {
      error {
        code
        message
      }
      eventVendors {
        __typename
        id
        productType
        ... on CateringEventVendor {
          packingSlipConfirmed
          purchaseOrderConfirmed
          packingSlipUrl
          purchaseOrderUrl
          vendor {
            id
            internalName
            address {
              id
              address1
              address2
              city
              state
              zipCode
              country
            }
          }
          event {
            id
            name
            startTime
            endTime
            status
            setupTime
            serviceStyle
            individualLabel
            servingUtensils
            utensilsPlatesNapkins
            chaffingFrames
            sternos
            account {
              id
              name
            }
            location {
              id
              name
              building {
                id
                name
                address {
                  id
                  address1
                  address2
                  city
                  state
                  zipCode
                  country
                }
              }
            }
          }
        }
      }
    }
  }
`);
